'use client';

import {
  FaFacebook,
  FaGlobe,
  FaInstagram,
  FaLinkedin,
  FaPinterest,
  FaRedditAlien,
  FaSnapchat,
  FaThreads,
  FaTiktok,
  FaWhatsapp,
  FaXTwitter,
  FaYoutube,
} from 'react-icons/fa6';

import { type PredefinedSocialType } from '@web/constants';

type Props = {
  type: PredefinedSocialType;
  size?: number;
  color?: string;
};

export function SocialProfileIcon({
  type,
  size = 18,
  color = 'var(--nn-text)',
}: Props) {
  const commonProps = {
    size,
    color,
    'aria-hidden': true,
  } as const;

  switch (type) {
    case 'linkedin':
      return <FaLinkedin {...commonProps} />;
    case 'facebook':
      return <FaFacebook {...commonProps} />;
    case 'x':
      return <FaXTwitter {...commonProps} />;
    case 'instagram':
      return <FaInstagram {...commonProps} />;
    case 'tiktok':
      return <FaTiktok {...commonProps} />;
    case 'whatsapp':
      return <FaWhatsapp {...commonProps} />;
    case 'youtube':
      return <FaYoutube {...commonProps} />;
    case 'snapchat':
      return <FaSnapchat {...commonProps} />;
    case 'threads':
      return <FaThreads {...commonProps} />;
    case 'reddit':
      return <FaRedditAlien {...commonProps} />;
    case 'pinterest':
      return <FaPinterest {...commonProps} />;
    case 'website':
    default:
      return <FaGlobe {...commonProps} />;
  }
}
